/**
 * @deprecated The AngularJS `header` directive has been migrated to Angular:
 *  - application mode → `app-header` (`<ng-header-app>`)
 *  - minimal mode     → `app-header-minimal` (`<ng-header-minimal>`)
 *  - print mode       → `app-header-print` (`<ng-header-print>`)
 *
 * The cart popover intentionally stays AngularJS as `<header-cart>` (see
 * header-cart.directive.ts) and is projected into `app-header`'s `<ng-content>`.
 *
 * No `header` directive is registered anymore. This module is retained only so
 * `HeaderDirectiveModule` consumers (e.g. views/application/application.ts) keep
 * wiring `<header-cart>` into the AngularJS module graph. Remove once the cart
 * itself is migrated and `<header-cart>` is registered elsewhere.
 */
import angular from 'angular';
import { HeaderCartDirectiveModule } from './header-cart.directive';

export const HeaderDirectiveModule = angular
  .module('acme.common.directive.header', [HeaderCartDirectiveModule])
  .name;
